import { defineComponent } from "vue";
import common from "../core/core";
import { mainModelService } from "@/services/main.model.service";

import * as Sentry from "@sentry/vue";

export default defineComponent({
  components: {},
  data() {
    return {
      ctaCitySelectOpened: false,
      mainModelService,
      tariffsService: this.$store.direct.getters.tariffsService,
    };
  },
  async mounted() {
    await this.$store.direct.getters.recaptchaService.init();

    this.AppService.phoneBlockSubject.subscribe(async (data) => {
      const containerId = (this.$refs.container as HTMLElement)?.querySelector("#phone-block-" + data.id)?.id;
      const phoneBlock = (this.$refs.container as HTMLElement)?.querySelector("#phone-block-" + data.id) as HTMLElement;
      const phoneBlockTechnology = phoneBlock?.dataset.technology;

      if (containerId === "phone-block-" + data.id) {
        const tariff = this.$store.direct.getters.tariffsService.getTariff();
        const address = this.$store.direct.getters.addressService.address; // TODO access via getter
        const hasCoverage = await this.$store.direct.getters.coverageService.getHasCoverage();
        const hasPlannedCoverage = await this.$store.direct.getters.coverageService.getHasPlannedCoverage();
        const clientCenterOpen = await this.$store.direct.getters.holidaysService.isClientCenterOpen();
        const token = await this.$store.direct.getters.recaptchaService.getToken("order");
        const phoneNumber = data.code + data.number;
        // Prepare the request
        const reqBuilder = this.$store.direct.getters.createWebOrderRequestBuilderFactory.create();
        reqBuilder.setPhone(phoneNumber);
        reqBuilder.setRecaptcha(token);

        // if technology-specific phone block
        if (phoneBlockTechnology !== undefined) {
          reqBuilder.setTechnology(phoneBlockTechnology);
        } else {
          reqBuilder.setAddress(address);
          reqBuilder.setTariff(tariff);
          reqBuilder.setHasCoverage(hasCoverage);
          reqBuilder.setHasPlannedCoverage(hasPlannedCoverage);
        }

        // Fire
        let webApiResponse = null;
        try {
          webApiResponse = await this.$store.direct.getters.webApiService.createWebOrder(await reqBuilder.getRequest());
          this.phoneBlockLoading = false;
          this.AppService.openPopup("form_success", {
            hasPlannedCoverage: hasPlannedCoverage,
            clientCenterOpen: clientCenterOpen,
          });
        } catch (error) {
          this.phoneBlockLoading = false;
          this.AppService.openPopup("form_error", {
            hasPlannedCoverage: hasPlannedCoverage,
          });
          Sentry.captureException(error);
        }
        // Track

        const trackingPayload = {
          web_order_uuid: webApiResponse?.uuid ?? null,
          url: window.location.pathname,
          city: address?.mesto,
          technology: tariff?.param_pvr, // 5e / wifi / gpon / bytovky / siim
          has_coverage: hasCoverage,
          phone_number: phoneNumber,
        };

        await Promise.all([
          this.$store.direct.getters.gtmService.trackOncePerSession("phone_submit_footer", trackingPayload),
          this.$store.direct.getters.exponeaService.trackOncePerSession("phone_submit_footer", trackingPayload),
        ]);
      }
    });
  },
  computed: {},
  methods: {
    toggleCtaCountrySelect() {
      this.ctaCitySelectOpened = !this.ctaCitySelectOpened;
    },
    closeCtaCountrySelect() {
      this.ctaCitySelectOpened = false;
    },
  },
  mixins: [common],
});
